// extracted by mini-css-extract-plugin
export default {"block":"PageSection_block__NlQzW","icon":"PageSection_icon__uBqjk","section":"PageSection_section__MCYTQ","title":"PageSection_title__-l2jr"};